<div class="page-layout">
  <app-sidebar></app-sidebar>

  <div class="main-area">
    <app-navbar pageTitle="Failed Documents" pageSubtitle="Documents that failed during ingestion (T1-T4), and why."></app-navbar>

    <div class="content-wrap">

      <div class="error-banner" *ngIf="error()">{{ error() }}</div>

      <div class="stat-cards" *ngIf="summary() as s">
        <div class="stat-card">
          <span class="stat-value">{{ s.total }}</span>
          <span class="stat-label">Pending Failures</span>
        </div>
        <div class="stat-card" *ngFor="let stage of s.byStage">
          <span class="stat-value">{{ stage.count }}</span>
          <span class="stat-label">{{ stageLabel(stage.stage) }}</span>
        </div>
      </div>

      <div class="toolbar">
        <select [(ngModel)]="stageFilter" (ngModelChange)="onFilterChange()">
          <option value="">All stages</option>
          <option value="T1">T1 · Scrape</option>
          <option value="T2">T2 · OCR</option>
          <option value="T3">T3 · Chunk &amp; Embed</option>
          <option value="T4">T4 · Enrich</option>
        </select>
        <select [(ngModel)]="statusFilter" (ngModelChange)="onFilterChange()">
          <option value="Pending">Pending</option>
          <option value="Retried">Retried</option>
          <option value="Dismissed">Dismissed</option>
          <option value="">All statuses</option>
        </select>
        <button class="refresh-btn" (click)="refresh()">Refresh</button>
        <button class="retry-all-btn" [disabled]="bulkBusy() || (summary()?.total ?? 0) === 0" (click)="retryAllFiltered()">
          {{ bulkBusy() ? 'Working…' : (stageFilter() ? 'Retry all in ' + stageLabel(stageFilter()) : 'Retry all pending') }}
        </button>
      </div>

      <div class="bulk-toolbar" *ngIf="selectedIds().size > 0">
        <span>{{ selectedIds().size }} selected</span>
        <button class="action-btn retry" [disabled]="bulkBusy()" (click)="bulkRetrySelected()">Retry selected</button>
        <button class="action-btn dismiss" [disabled]="bulkBusy()" (click)="bulkDismissSelected()">Dismiss selected</button>
      </div>

      <div class="table-wrap">
        <table class="dlq-table" *ngIf="entries().length > 0; else emptyState">
          <thead>
            <tr>
              <th class="checkbox-cell"><input type="checkbox" [checked]="allOnPageSelected" (change)="toggleSelectAllOnPage()" /></th>
              <th>Stage</th>
              <th>File</th>
              <th>Error</th>
              <th>Retries</th>
              <th>Failed At</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let entry of entries()" [class.row-selected]="isSelected(entry.id)">
              <td class="checkbox-cell"><input type="checkbox" [checked]="isSelected(entry.id)" (change)="toggleSelected(entry.id)" /></td>
              <td><span class="stage-badge">{{ entry.stage }}</span></td>
              <td class="file-cell" [title]="entry.fileName">{{ entry.fileName }}</td>
              <td class="error-cell" [title]="entry.error">
                <span class="error-type">{{ entry.errorType }}</span>
                <span class="error-text">{{ entry.error }}</span>
              </td>
              <td>{{ entry.retryCount }}</td>
              <td>{{ entry.createdAt | date:'medium' }}</td>
              <td><span class="status-badge" [class.pending]="entry.status === 'Pending'">{{ entry.status }}</span></td>
              <td class="actions-cell">
                <ng-container *ngIf="entry.status === 'Pending'">
                  <button class="action-btn retry" [disabled]="isBusy(entry.id)" (click)="retry(entry)">Retry</button>
                  <button class="action-btn dismiss" [disabled]="isBusy(entry.id)" (click)="dismiss(entry)">Dismiss</button>
                </ng-container>
              </td>
            </tr>
          </tbody>
        </table>
        <ng-template #emptyState>
          <div class="empty-state" *ngIf="!loading()">No DLQ entries match this filter.</div>
        </ng-template>
      </div>

      <div class="pagination" *ngIf="totalPages() > 1">
        <button (click)="goToPage(page() - 1)" [disabled]="page() <= 1">Previous</button>
        <span>Page {{ page() }} of {{ totalPages() }}</span>
        <button (click)="goToPage(page() + 1)" [disabled]="page() >= totalPages()">Next</button>
      </div>

    </div>
  </div>
</div>
